var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "number number-align-" + _vm.localAlign }, [
    !_vm.editingFieldLabel
      ? _c(
          "label",
          {
            staticClass: "field-label",
            attrs: { for: "number" },
            on: { click: _vm.focusFieldLabel },
          },
          [
            _vm._v("\n        " + _vm._s(_vm.displayFieldLabel) + "\n        "),
            _vm.isRequired
              ? _c("span", { staticClass: "required-indicator" }, [_vm._v("*")])
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.editingFieldLabel
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localFieldLabel,
              expression: "localFieldLabel",
            },
          ],
          ref: "fieldLabelInput",
          staticClass: "field-label-input",
          attrs: { type: "text", placeholder: "Bir sayı girin" },
          domProps: { value: _vm.localFieldLabel },
          on: {
            blur: _vm.stopEditingFieldLabel,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.stopEditingFieldLabel.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localFieldLabel = $event.target.value
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "input-container" }, [
      _c("div", { class: ["input-wrapper", { filled: _vm.numberValue }] }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.numberValue,
              expression: "numberValue",
            },
          ],
          class: { "has-value": _vm.numberValue },
          attrs: { type: "number", id: "number", name: "number" },
          domProps: { value: _vm.numberValue },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.numberValue = $event.target.value
              },
              _vm.updateField,
            ],
            focus: _vm.onFocus,
            blur: _vm.onBlur,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "input-border" }),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "input-label", attrs: { for: "number" } }, [
        _vm._v(_vm._s(_vm.subLabel || "Lütfen bir sayı giriniz")),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }